import React, { Component, Fragment } from 'react';
import { Button, Dropdown, Form, Header, Icon, Label, Segment, SegmentGroup } from 'semantic-ui-react';
import {
    checkOrganizationalUnitsPrivilege,
    checkWritePrivilege,
    DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
    formatListForDropdownOptions,
    getTotalNumberOfPages
} from '../util/util';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import PropertyTable from './PropertyTable';
import { Redirect } from 'react-router-dom';
import { FiltersOnStyle, IconHeader } from '../util/css';
import PaginationSegment from '../util/PaginationSegment';
import Loader from 'semantic-ui-react/dist/commonjs/elements/Loader';
import { fetchFaculties } from '../../Lookups/util';

const v = (val) => val != null && val !== '' ? val : '-';

// @formatter: off
const ALL_COLUMNS = [
    { key: 'organizationalUnitName', displayName: 'Članica', accessor: (el) => el.organizationalUnit && el.organizationalUnit.name },
    { key: 'propertyName', displayName: 'Naziv imovine', accessor: (el) => el.property && el.property.name },
    { key: 'propertyTypeName', displayName: 'Tip imovine', accessor: (el) => el.property && el.property.propertyType && el.property.propertyType.name },
    { key: 'street', displayName: 'Ulica', accessor: (el) => v(el.property && el.property.address && el.property.address.street) },
    { key: 'place', displayName: 'Mjesto', accessor: (el) => v(el.property && el.property.address && el.property.address.place && el.property.address.place.name) },
    { key: 'municipality', displayName: 'Opština', accessor: (el) => el.property && el.property.address && el.property.address.place && el.property.address.place.municipality && el.property.address.place.municipality.name },
    { key: 'canton', displayName: 'Kanton', accessor: (el) => el.property && el.property.address && el.property.address.place && el.property.address.place.canton && el.property.address.place.canton.name },
    { key: 'entity', displayName: 'Entitet', accessor: (el) => el.property && el.property.address && el.property.address.place && el.property.address.place.entity && el.property.address.place.entity.name },
    { key: 'country', displayName: 'Država', accessor: (el) => el.property && el.property.address && el.property.address.place && el.property.address.place.country && el.property.address.place.country.name },
    { key: 'landRegistryArea', displayName: 'Površina (m²) - ZK', accessor: (el) => v(el.property && el.property.landRegistryArea) },
    { key: 'landRegistryEntryNumber', displayName: 'Broj katastarskog uloška', accessor: (el) => v(el.property && el.property.landRegistryEntryNumber) },
    { key: 'landRegistryMunicipalCadastre', displayName: 'Opštinski katastar (ZK)', accessor: (el) => el.property && el.property.landRegistryMunicipalCadastre && el.property.landRegistryMunicipalCadastre.name },
    { key: 'landRegistryRightsScopeNotes', displayName: 'Obim prava (ZK)', accessor: (el) => v(el.property && el.property.landRegistryRightsScopeNotes) },
    { key: 'encumbrances', displayName: 'Tereti', accessor: (el) => v(el.property && el.property.encumbrances) },
    { key: 'bListNotes', displayName: 'B-lista napomene', accessor: (el) => v(el.property && el.property.bListNotes) },
    { key: 'possessionSheetNumber', displayName: 'Broj posjedovnog lista', accessor: (el) => v(el.property && el.property.possessionSheetNumber) },
    { key: 'possessionMunicipalCadastre', displayName: 'Opštinski katastar (KP)', accessor: (el) => el.property && el.property.possessionMunicipalCadastre && el.property.possessionMunicipalCadastre.name },
    { key: 'possessionArea', displayName: 'Površina (m²) - KP', accessor: (el) => v(el.property && el.property.possessionArea) },
    { key: 'possessionRightsScopeNotes', displayName: 'Obim prava (KP)', accessor: (el) => v(el.property && el.property.possessionRightsScopeNotes) },
    { key: 'harmonized', displayName: 'Usklađeno', accessor: (el) => el.property && el.property.harmonized != null ? (el.property.harmonized ? 'Da' : 'Ne') : '-' },
    { key: 'ownershipEvidence', displayName: 'Dokazi o vlasništvu', accessor: (el) => v(el.property && el.property.ownershipEvidence) },
    { key: 'acquisitionValue', displayName: 'Nabavna vrijednost', accessor: (el) => v(el.property && el.property.acquisitionValue) },
    { key: 'valueAdjustment', displayName: 'Valorizacija', accessor: (el) => v(el.property && el.property.valueAdjustment) },
    { key: 'bookValue', displayName: 'Knjigovodstvena vrijednost', accessor: (el) => v(el.property && el.property.bookValue) },
    { key: 'jointInvestmentRightsScopeNotes', displayName: 'Obim prava (zajednička ulaganja)', accessor: (el) => v(el.property && el.property.jointInvestmentRightsScopeNotes) },
    { key: 'notes', displayName: 'Napomene', accessor: (el) => v(el.property && el.property.notes) },
    { key: 'additionalNotes', displayName: 'Dodatne napomene', accessor: (el) => v(el.property && el.property.additionalNotes) },
];
// @formatter: on

const DEFAULT_SELECTED_COLUMNS = ['organizationalUnitName', 'propertyName', 'propertyTypeName', 'street', 'place'];

const columnOptions = ALL_COLUMNS.map(col => ({
    key: col.key,
    text: col.displayName,
    value: col.key,
}));

const SEARCH_FIELDS = ['_searchProperty', '_searchOrgUnit', '_searchType', '_searchStreet', '_searchPlace', '_searchNotes'];

const addSearchFields = (items) => items.map(item => ({
    ...item,
    _searchProperty: item.property && item.property.name ? item.property.name : '',
    _searchOrgUnit: item.organizationalUnit && item.organizationalUnit.name ? item.organizationalUnit.name : '',
    _searchType: item.property && item.property.propertyType && item.property.propertyType.name ? item.property.propertyType.name : '',
    _searchStreet: item.property && item.property.address && item.property.address.street ? item.property.address.street : '',
    _searchPlace: item.property && item.property.address && item.property.address.place && item.property.address.place.name ? item.property.address.place.name : '',
    _searchNotes: item.property && item.property.notes ? item.property.notes : '',
}));

const sanitize = (val) => {
    if (val == null) return '';
    if (val === '-') return '';
    if (typeof val === 'boolean') return val ? 'Da' : 'Ne';
    return String(val);
};

const prepareExcelData = (properties) => [{
    columns: ALL_COLUMNS.map(col => ({
        title: col.displayName,
        width: { wpx: 200 }
    })),
    data: properties.map(item =>
        ALL_COLUMNS.map(col => ({
            value: sanitize(col.accessor(item))
        }))
    )
}];

class Property extends Component {
    columns = ALL_COLUMNS;

    constructor(props, context) {
        super(props, context);

        this.state = {
            loading: true,
            editingProperty: null,

            activePage: 1,
            totalPages: 1,
            resultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
            filterRequestData: null,
            organizationalUnitProperties: [],
            allOrganizationalUnitProperties: [],

            organizationalUnitOptions: [],
            selectedOrganizationalUnit: null,
            selectedColumns: JSON.parse(localStorage.getItem('propertySelectedColumns')) || DEFAULT_SELECTED_COLUMNS,
            isColumnDropdownOpen: false,

            searchText: '',
            filteredOrganizationalUnitProperties: [],
            excelData: [],

            deletingRowId: null,
            saving: false,
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.updateOrganizationalUnitProperties = this.updateOrganizationalUnitProperties.bind(this);
        this.fetchOrganizationalUnitProperties = this.fetchOrganizationalUnitProperties.bind(this);
        this.handleColumnChange = this.handleColumnChange.bind(this);
    }

    componentDidMount() {
        // TODO: Fetch active role from backend
        fetchFaculties()
            .then(response => {
                this.setState({
                    organizationalUnitOptions: formatListForDropdownOptions(response.data),
                    selectedOrganizationalUnit: Number(localStorage.getItem('ouId')) || null,
                }, () => this.fetchData());
            });
    }

    fetchData() {
        this.setState({ loading: true });
        this.fetchOrganizationalUnitProperties(0, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
    }

    onChangeOrganizationalUnit(selectedOrganizationalUnit) {
        this.setState({ selectedOrganizationalUnit }, () => this.fetchData());
        if (selectedOrganizationalUnit) {
            localStorage.setItem('ouId', selectedOrganizationalUnit);
        } else {
            localStorage.removeItem('ouId');
        }
    }

    fetchOrganizationalUnitProperties(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };
        const organizationalUnitId = this.state.selectedOrganizationalUnit;
        const urlSuffix = organizationalUnitId ? `${organizationalUnitId}/` : '';
        axios.post('/assets/organizational-unit-properties/paginated/' + urlSuffix, { ...pagination })
            .then((res) => {
                const allOrganizationalUnitProperties = res.data.responseList;
                const withSearchFields = addSearchFields(allOrganizationalUnitProperties);
                let totalPages = getTotalNumberOfPages(res.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
                this.setState({
                    organizationalUnitProperties: allOrganizationalUnitProperties,
                    allOrganizationalUnitProperties: withSearchFields,
                    filteredOrganizationalUnitProperties: withSearchFields,
                    excelData: prepareExcelData(withSearchFields),
                    totalPages,
                    loading: false
                });
                this.updateOrganizationalUnitProperties(page, resultsPerPage, res);
            });
    }

    handlePageChange(e, { activePage }) {
        if (activePage === this.state.activePage) return;
        this.fetchOrganizationalUnitProperties(activePage - 1, this.state.resultsPerPage);
    }

    updateOrganizationalUnitProperties(page, resultsPerPage, res) {
        let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);
        this.setState(prevState => ({
            activePage: page + 1,
            resultsPerPage,
            totalPages,
        }));
    }

    handleColumnChange(e, { value }) {
        if (value.length > 8 || value.length < 4) {
            toast('Ne može se prikazati manje od 4 ili više od 8 kolona');
            return;
        }
        this.setState({ selectedColumns: value });
        localStorage.setItem('propertySelectedColumns', JSON.stringify(value));
    }

    getResults = (results) => {
        if (results.length === 0 && this.state.searchText.trim() === '') {
            const withSearchFields = addSearchFields(this.state.organizationalUnitProperties);
            this.setState({
                filteredOrganizationalUnitProperties: withSearchFields,
                excelData: prepareExcelData(withSearchFields),
            });
        } else {
            this.setState({
                filteredOrganizationalUnitProperties: results,
                excelData: prepareExcelData(results),
            });
        }
    };

    handleSearchTextChange = (text) => {
        this.setState({ searchText: text });
    };

    handleDeleteClick = (id) => {
        this.setState({ deletingRowId: id });
    };

    handleCancelClick = () => {
        this.setState({ deletingRowId: null });
    };

    handleConfirmClick = () => {
        const { deletingRowId } = this.state;
        this.setState({ saving: true });
        axios.delete(`/assets/organizational-unit-properties/${deletingRowId}/`)
            .then(res => {
                toast('Uspješno obrisano!');
                this.setState({
                    deletingRowId: null,
                    saving: false
                });
                this.fetchData();
            })
            .catch(err => {
                const msg = err && err.response && err.response.data ? err.response.data : '';
                if (msg.includes('ConstraintViolationException')) {
                    toast(<FormattedMessage id="assets.organizationalUnitProperties.deleteConstraintError"/>);
                } else {
                    toast(<FormattedMessage id="assets.organizationalUnitProperties.deleteError"/>);
                }
                this.setState({
                    deletingRowId: null,
                    saving: false
                });
            });
    };

    render() {
        if (this.state.activateDetailsRequest) {
            return <Redirect push to={{ pathname: '/imovina/nepokretna-imovina/detalji' }}/>;
        }

        if (this.state.openPropertyForm) {
            return <Redirect push to={{ pathname: '/imovina/nepokretna-imovina/kreiranje' }}/>;
        }

        const activeRole = localStorage.getItem('activeRole');

        return (
            <div>
                <Header as="h1">Nepokretna imovina</Header>
                <SegmentGroup raised>
                    <Segment>
                        <Header as="h3">
                            Spisak nepokretne imovine
                            <Header style={IconHeader} floated="right">
                                {checkWritePrivilege(activeRole) &&
                                    // Only university super admin and OU admin can add new property
                                    <Button
                                        color="blue"
                                        floated="right"
                                        icon
                                        labelPosition="right"
                                        size="small"
                                        style={FiltersOnStyle}
                                        onClick={() => this.setState({ openPropertyForm: true })}
                                    ><Icon className="add"/>
                                        Dodavanje nove nepokretne imovine
                                    </Button>}
                            </Header>

                        </Header>
                    </Segment>
                    {checkOrganizationalUnitsPrivilege(activeRole) &&
                        // Only university super admin and university admin can filter by OU
                        <Segment>
                            <Form>
                                <Form.Field>
                                    <label>Članica</label>
                                    <Form.Dropdown
                                        disabled={this.state.loading}
                                        search
                                        options={this.state.organizationalUnitOptions}
                                        value={this.state.selectedOrganizationalUnit || null}
                                        selection
                                        clearable={true}
                                        placeholder={'Odaberite članicu'}
                                        onChange={(e, { value }) => this.onChangeOrganizationalUnit(value)}/>
                                </Form.Field>
                            </Form>
                        </Segment>
                    }
                    <Segment>
                        {
                            this.state.loading ?
                                <div style={{
                                    paddingTop: '20px',
                                    paddingBottom: '20px'
                                }}><Loader active inline="centered"/></div> :
                                (this.state.organizationalUnitProperties && this.state.organizationalUnitProperties.length !== 0) ?
                                    <Fragment>
                                        {this.state.isColumnDropdownOpen &&
                                            <div>
                                                <Dropdown
                                                    fluid
                                                    multiple
                                                    search
                                                    selection
                                                    options={columnOptions}
                                                    value={this.state.selectedColumns}
                                                    onChange={this.handleColumnChange}
                                                    placeholder="Odaberite kolone"
                                                />
                                            </div>
                                        }
                                        <PropertyTable
                                            writePrivilege={checkWritePrivilege(activeRole)}
                                            allOrganizationalUnitProperties={this.state.allOrganizationalUnitProperties}
                                            filteredOrganizationalUnitProperties={this.state.filteredOrganizationalUnitProperties}
                                            columns={ALL_COLUMNS.filter(col => this.state.selectedColumns.includes(col.key))}
                                            isColumnDropdownOpen={this.state.isColumnDropdownOpen}
                                            toggleColumnDropdown={() => this.setState({ isColumnDropdownOpen: !this.state.isColumnDropdownOpen })}
                                            activateEditRequest={(property) => {
                                                this.setState({ editingProperty: property });
                                            }}
                                            activateDetailsRequest={() => {
                                                this.setState({ activateDetailsRequest: true });
                                            }}
                                            excelData={this.state.excelData}
                                            getResults={this.getResults}
                                            handleSearchTextChange={this.handleSearchTextChange}
                                            deletingRowId={this.state.deletingRowId}
                                            saving={this.state.saving}
                                            handleDeleteClick={this.handleDeleteClick}
                                            handleConfirmClick={this.handleConfirmClick}
                                            handleCancelClick={this.handleCancelClick}
                                        />
                                        <PaginationSegment
                                            activePage={this.state.activePage}
                                            totalPages={this.state.totalPages}
                                            onPageChange={this.handlePageChange}
                                        />
                                    </Fragment>
                                    : ('Nema podataka za prikaz.')
                        }

                    </Segment>
                    <ToastContainer hideProgressBar/>
                </SegmentGroup>
            </div>
        );
    }
}

export default Property;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/Property.js